module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_2_TECNOLÓGICO.9503699f.jpg";